import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import useMedia from "use-media";
import { BadgesPanel } from "~/components/badges/BadgesPanel.jsx";
import { clubHasFlight } from "~/featureMatrix.jsx";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";
import { persistActions } from "~/redux/actions.js";
import { BevoegdhedenClusterTab } from "../bevoegdheden/BevoegdhedenClusterTab.jsx";
import { HelpBubble } from "../help/helpBubble.jsx";
import { Loader } from "../loader/loader.jsx";
import { InstructorRefresher } from "./instructorRefresher.jsx";
import { NotitieModal } from "./notitieModal.jsx";
import { Bestanden } from "./tabs/bestanden.jsx";
import { DTOtrainingTab } from "./tabs/dtoTraining.jsx";
import { LastFlights } from "./tabs/LastFlights.jsx";
import { Notities } from "./tabs/notities.jsx";
import { Recency } from "./tabs/overviewFlights.jsx";
import { getUserAvatar, UserAvatar } from "./UserAvatar.jsx";
import { VliegerStats } from "./vliegerStats.jsx";

function successUserGroupBevoegdheid(content) {
  // Delay modal to avoid React DOM conflicts
  setTimeout(() => {
    Modal.success({
      content: (
        <div>
          <p>{content}</p>
          <p className="small alert" style={{ marginTop: 12 }}>
            {$t(
              "Deze wijzigen zullen in de loop van de dag doorgevoerd worden in alle currency systemen.",
            )}
          </p>
        </div>
      ),
    });
  }, 0);
}

const UserProfileUnconnected = ({
  pilot,
  currentUser,
  bevoegdheden,
  allDays,
  getVliegerProfile,
  link,
  club,
}) => {
  const isWide = useMedia({ minWidth: "500px" }, true);
  const [modalOpen, setModalOpen] = useState(false);
  const [notitie, setNotitie] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(
    () => sessionStorage.getItem("lastUserProfileTab") || "notities",
  );

  const [pilotData, setData] = useState({});
  const setBevoegdheid = async (payload) => {
    // set bevoegheid and save to pilotData for use in model
    const res = await api.post("bevoegdheid/set.json", payload);
    if (res) {
      const behaalde_bevoegdheden = { ...pilotData.behaalde_bevoegdheden };
      behaalde_bevoegdheden[res.bevoegdheid_id] = {
        ...res,
        assigned: res.score === 5 || res.score == "assigned",
      };
      setData({ ...pilotData, behaalde_bevoegdheden });
      if (res.message) successUserGroupBevoegdheid(res.message);
    }
  };

  const addFlightToProfile = ({ flight }) => {
    // update element f in pilotData.flights
    let flights = [flight];
    if (pilotData.flights?.length > 0) {
      flights = pilotData.flights.map((f) => {
        if (f.uuid == flight.uuid) return flight;
        return f;
      });
    }
    setData({ ...pilotData, flights: flights });
  };

  const src_avatar = getUserAvatar(pilot.uuid ? pilot : pilotData);

  // for updates we retrieve it for each flight
  useEffect(() => {
    // on load we automatically check data if required, otherwise only do this whenever you press open data
    const loadData = async (pilot) => {
      if (pilot) {
        setLoading(true);
        const res = await getVliegerProfile({ id: pilot.id });
        if (res) setData(res);
        setLoading(false);
      }
    };
    setData(pilot);
    loadData(pilot);
  }, [pilot, currentUser, getVliegerProfile, setData, setLoading]);

  const onAddNotitie = (notitie) => {
    let newNotities = pilotData.notities
      ? pilotData.notities.filter((n) => n.id !== notitie.id)
      : [];
    if (!notitie.action || notitie.action !== "deleted") {
      newNotities = [notitie].concat(newNotities);
    }
    setData({
      ...pilotData,
      notities: newNotities,
    });
    setModalOpen(false);
  };

  const onAddBestand = (bestanden) => {
    setData({
      ...pilotData,
      bestanden,
    });
    setModalOpen(false);
  };

  const onAddDTOprogramme = (dto_training) => {
    setData({
      ...pilotData,
      dto_training,
    });
  };

  const hasFlights = clubHasFlight();
  const isInstructorOrPilot =
    currentUser.is_instructeur || currentUser.id === pilot.id;

  const hasBadges =
    hasFlights &&
    club?.has_badges &&
    ["dbo", "solist"].some((k) => pilotData.group_keys?.includes(k)) && 
    // TODO BADGES: remove test in localStorage
    localStorage.getItem("badges") === "true"

  if (pilot) {
    const tabItems = [
      ...(isInstructorOrPilot
        ? [
            {
              key: "notities",
              label: $t("Notities"),
              children: (
                <>
                  {currentUser.is_instructeur && (
                    <div className="row" style={{ marginBottom: 12 }}>
                      <Button
                        icon={<PlusOutlined />}
                        size="small"
                        type="link"
                        style={{ padding: 0, marginRight: 6 }}
                        onClick={() => {
                          setNotitie({
                            id: null,
                            bericht: "",
                            is_kritiek: false,
                            is_prive: false,
                          });
                          setModalOpen(true);
                        }}
                      >
                        {$t("Voeg notitie toe")}
                      </Button>
                      <HelpBubble
                        content={$t(
                          "Alleen instructeurs mogen notities achterlaten.",
                        )}
                      />
                    </div>
                  )}
                  <Notities
                    notities={pilotData.notities}
                    currentUserID={currentUser.id}
                    alleenPublic={currentUser.id === pilot.id}
                    openNotitie={(notitie) => {
                      setNotitie(notitie);
                      setModalOpen(true);
                    }}
                  />
                </>
              ),
            },
            ...(hasFlights
              ? [
                  {
                    key: "recency",
                    label: $t("Recency"),
                    children: (
                      <>
                        {currentUser.wijzig_dto &&
                          (pilotData.is_instructeur || pilotData.is_bis) &&
                          pilotData.recency && (
                            <InstructorRefresher
                              pilot={pilotData}
                              recency={pilotData.recency}
                              setRecency={(r) =>
                                r && setData({ ...pilotData, recency: r })
                              }
                            />
                          )}
                        <Recency
                          recency={pilotData.recency}
                          profile={pilotData}
                        />
                      </>
                    ),
                  },
                  {
                    key: "vluchten",
                    label: $t("Vluchten"),
                    children: (
                      <LastFlights
                        pilot={pilot}
                        addFlightToProfile={addFlightToProfile}
                      />
                    ),
                  },
                ]
              : []),
          ]
        : []),
      ...(hasBadges
        ? [
            {
              key: "badges",
              label: $t("Badges"),
              children: <BadgesPanel userId={pilot.id} />,
            },
          ]
        : []),
      ...(pilotData.behaalde_bevoegdheden && bevoegdheden
        ? bevoegdheden
            .filter(
              (cluster) =>
                // always show if cluster is not dto, or otherwise only if dto training has started
                // only if instructor or your own profile
                !cluster.is_dto ||
                ((isInstructorOrPilot || currentUser.uitgifte_bevoegheid) &&
                  pilotData.dto_training &&
                  pilotData.dto_training[cluster.id] &&
                  pilotData.dto_training[cluster.id].status === "started"),
            )
            .map((cluster, key) => ({
              key: cluster.name,
              label: cluster.name,
              children: (
                <BevoegdhedenClusterTab
                  pilot={pilot}
                  behaalde_bevoegdheden={pilotData.behaalde_bevoegdheden}
                  cluster={cluster}
                  currentUser={currentUser}
                  setBevoegdheid={setBevoegdheid}
                />
              ),
            }))
        : []),
      ...(isInstructorOrPilot
        ? [
            {
              key: "bestanden",
              label: $t("Bestanden"),
              children: (
                <Bestanden
                  currentUser={currentUser}
                  bestanden={pilotData.bestanden}
                  pilot={pilot}
                  onAddBestand={onAddBestand}
                />
              ),
            },
            {
              key: "DTO",
              label: $t("DTO"),
              children: (
                <DTOtrainingTab
                  canWijzigDTO={currentUser.wijzig_dto}
                  dto_training={pilotData.dto_training}
                  bevoegdheden={bevoegdheden}
                  pilot={pilot}
                  onAddDTOprogramme={onAddDTOprogramme}
                  gegevens={pilotData && pilotData.gegevens}
                />
              ),
            },
          ]
        : []),
    ];

    const resolvedTab = tabItems.some((t) => t.key === activeTab)
      ? activeTab
      : tabItems[0]?.key;

    return (
      <div>
        <NotitieModal
          visible={modalOpen}
          notitie={notitie}
          onCancel={() => {
            setModalOpen(false);
            setNotitie(null);
          }}
          onOk={onAddNotitie}
          allDays={allDays}
          pilot={pilot}
        />

        {!isWide && (
          <UserAvatar user={pilot} size={140} className="modalAvatar spacer" />
        )}

        <div className="row">
          <div style={{ marginRight: 12, flexShrink: 0 }}>
            {isWide && pilot && (
              <UserAvatar user={pilot} size={200} className="modalAvatar" />
            )}
          </div>

          <VliegerStats
            club={club}
            currentProfile={currentUser}
            link={link}
            pilot={pilotData}
            gegevens={pilotData && pilotData.gegevens}
            showName
            isInstructorOrPilot={isInstructorOrPilot}
            canWijzigDTO={currentUser.wijzig_dto}
            onUpdateVliegerdata={(d) => setData(d)}
          />
        </div>

        {loading && <Loader />}

        {!loading && (
          <Tabs
            activeKey={resolvedTab}
            onChange={(key) => {
              setActiveTab(key);
              sessionStorage.setItem("lastUserProfileTab", key);
            }}
            items={tabItems}
          />
        )}
      </div>
    );
  }
  return null;
};

const mapStateToProps = (state) => ({
  currentUser: state.persist.profile,
  allDays: state.days.allDays,
  bevoegdheden: state.flights.bevoegdheden,
  club: state.persist.club,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getVliegerProfile: (data) =>
      dispatch(persistActions.getVliegerProfile(data)),
  };
};

export const UserProfile = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserProfileUnconnected);
